import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { showToast } from '../../components/common/toast/Toast'
import {
  useAddCustomerMutation,
  useUpdateCustomerMutation,
  useUpdateCustomerStatusMutation,
} from '../../api/app/CustomerApiService'
import {
  GenericAPIResponse,
  SerializedError,
} from '../../interface/response/CommonResponse'
import {
  AddCustomerRequest,
  UpdateCustomerRequest,
  UpdateCustomerStatusRequest,
} from '../../interface/request/CustomerRequest'

const useCustomerDetails = () => {
  const { t } = useTranslation(['translation'])
  const [addCustomer] = useAddCustomerMutation()
  const [updateCustomer] = useUpdateCustomerMutation()
  const [updateCustomerStatus] = useUpdateCustomerStatusMutation()
  const [showCustomerDetailsForm, setShowCustomerDetailsForm] = useState(false)
  const [isCustomerDetailsEdit, setIsCustomerDetailsEdit] = useState(false)
  const [showRejectCustomerAlert, setShowRejectCustomerAlert] = useState(false)
  const [showApproveCustomerAlert, setShowApproveCustomerAlert] =
    useState(false)

  const handleCustomerDetailsEdit = () => {
    setIsCustomerDetailsEdit(true)
    setShowCustomerDetailsForm(true)
  }
  const onCloseCustomerDetailsFormModal = () => {
    setShowCustomerDetailsForm(false)
    setIsCustomerDetailsEdit(false)
  }
  const onCloseCustomerRejectAlert = () => {
    setShowRejectCustomerAlert(false)
  }
  const onCloseCustomerApproveAlert = () => {
    setShowApproveCustomerAlert(false)
  }
  const handleOnClickReject = () => {
    setShowRejectCustomerAlert(true)
  }
  const handleOnClickApprove = () => {
    setShowApproveCustomerAlert(true)
  }
  const displayErrorToast = (message: string, code: number | string) => {
    showToast(`${message}(${code})`, 'error')
  }

  const addNewCustomer = (values: AddCustomerRequest) => {
    addCustomer(values)
      .unwrap()
      .then((response: GenericAPIResponse) => {
        if (response?.requestStatus) {
          showToast(t(`messages.${response?.code}`))
        } else {
          displayErrorToast(t(`messages.${response?.code}`), response?.code)
        }
      })
      .catch((error: SerializedError) => {
        displayErrorToast(t(`messages.${error?.status}`), error?.status)
      })
  }

  const updateCustomerInfo = (values: UpdateCustomerRequest) => {
    updateCustomer(values)
      .unwrap()
      .then((response: GenericAPIResponse) => {
        if (response?.requestStatus) {
          showToast(t(`messages.${response?.code}`))
        } else {
          displayErrorToast(t(`messages.${response?.code}`), response?.code)
        }
      })
      .catch((error: SerializedError) => {
        displayErrorToast(t(`messages.${error?.status}`), error?.status)
      })
  }

  const approveCustomerStatus = (values: UpdateCustomerStatusRequest) => {
    updateCustomerStatus(values)
      .unwrap()
      .then((response: GenericAPIResponse) => {
        if (response?.requestStatus) {
          showToast(t(`messages.${response?.code}`))
        } else {
          displayErrorToast(t(`messages.${response?.code}`), response?.code)
        }
        setShowApproveCustomerAlert(false)
      })
      .catch((error: SerializedError) => {
        displayErrorToast(t(`messages.${error?.status}`), error?.status)
        setShowApproveCustomerAlert(false)
      })
  }
  const rejectCustomerStatus = (values: UpdateCustomerStatusRequest) => {
    updateCustomerStatus(values)
      .unwrap()
      .then((response: GenericAPIResponse) => {
        if (response?.requestStatus) {
          showToast(t(`messages.${response?.code}`))
        } else {
          displayErrorToast(t(`messages.${response?.code}`), response?.code)
        }
        setShowRejectCustomerAlert(false)
      })
      .catch((error: SerializedError) => {
        displayErrorToast(t(`messages.${error?.status}`), error?.status)
        setShowRejectCustomerAlert(false)
      })
  }

  return {
    handleCustomerDetailsEdit,
    onCloseCustomerDetailsFormModal,
    onCloseCustomerRejectAlert,
    onCloseCustomerApproveAlert,
    handleOnClickReject,
    handleOnClickApprove,
    addNewCustomer,
    updateCustomerInfo,
    showCustomerDetailsForm,
    isCustomerDetailsEdit,
    showRejectCustomerAlert,
    showApproveCustomerAlert,
    approveCustomerStatus,
    rejectCustomerStatus,
  }
}

export default useCustomerDetails
